import { t } from "i18next";
import { SubTaskGroup, SubTaskPrompt, SubTaskRole, SubTaskStudent } from "../../interfaces/Task";

export interface SiteSubtaskGroupProps {
    group: SubTaskGroup;
    rols: SubTaskRole[];
    prompts: SubTaskPrompt[];
}

export default function SiteSubtaskGroup(props: SiteSubtaskGroupProps) {
    const itemStyle = {
        backgroundColor: props.group.color
    }

    return(
        <div className="site-sub-task-group-container" key={ 'sub-task-group-' + props.group._id } style={ itemStyle }>
            <div className="title">{ props.group.name }</div>
            <div className="content">
                <div className="info">{ t("Number of students") }: { props.group.students.length }</div>
                { props.group.students.length > 0 &&
                    <div className="students-list">
                        { props.group.students.map((s: SubTaskStudent) => {
                            return <div className="student-item">
                                    <div className="name">{ s.name }</div>
                                    { s.prompt == -1 && <div className="prompt">&raquo; { t("No prompt assigned") }</div> }
                                    { s.prompt != -1 && <div className="prompt">&raquo; { t("Prompt") }: { props.prompts[s.prompt].name }</div> }
                                    { s.role == -1 && <div className="role">&raquo; { t("No role assigned") }</div> }
                                    { s.role != -1 && <div className="role">&raquo; { t("Role") }: <span style={{backgroundColor: props.rols[s.role].color}}>{ props.rols[s.role].name }</span></div> }
                                </div>;
                        })}
                    </div>
                }
            </div>
        </div>
    );
}